import BaseProxy from './BaseProxy';

class News extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/news', parameters);
    }
}

export default News;



// WEBPACK FOOTER //
// ./src/api/News.js